module.exports = __webpack_public_path__ + "static/four_arrows-57ea6c6be46968af2b100f1b97edd2ad.png";